import { useScheduleManage } from '#providers/SchedulesManage';
import CoachMark from '#shared/CoachMark';
import { PrevHeaderBarWithTitleTemplate } from '#templates';
import { useEffect, useRef, useState } from 'react';
import 'react-dropdown/style.css';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import LectureScheduleContents, {
  LectureScheduleHandle
} from './LectureScheduleContents';
import PersonalScheduleContents, {
  PersonalScheduleHandle
} from './PersonalScheduleContents';
import { SCHEDULE_REGISTRATION_TAB_LIST } from './constants';
import * as S from './styles';
import { useSetRecoilState } from 'recoil';
import { $membership } from './LectureScheduleContents/useScheduleMembership';

/**
 * available: 회차정보 있음
 * none: 회차정보 없음
 * expiration: 모든 회차를 모두 완료
 */
export type RoundStatus = 'available' | 'none' | 'expiration';

export function WeeklyCalenderScheduleRegistration() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const setMembership = useSetRecoilState($membership);

  const [searchParams] = useSearchParams();
  const lectureScheduleId = searchParams.get('lecture-schedule-id');
  const personalScheduleId = searchParams.get('personal-schedule-id');
  const lectureScheduleRef = useRef<LectureScheduleHandle>(
    {} as LectureScheduleHandle
  );
  const personalScheduleRef = useRef<PersonalScheduleHandle>(
    {} as PersonalScheduleHandle
  );
  const [activeTab, setActiveTab] = useState<string>('LECTURE');
  const [hiddenTab, setHiddenTab] = useState<boolean>();
  const { clearSelectedLecture, clearGroupMembers } = useScheduleManage();

  const handleSave = () => {
    if (activeTab === 'LECTURE') {
      lectureScheduleRef.current.handleSave();
    } else {
      personalScheduleRef.current.handleSave();
    }
  };

  useEffect(() => {
    const handleBeforeUnload = () => {
      clearSelectedLecture();
    };

    window.addEventListener('popstate', handleBeforeUnload);

    return () => {
      setTimeout(
        () => window.removeEventListener('popstate', handleBeforeUnload),
        10
      );
    };
  }, []);

  useEffect(() => {
    return () => {
      if (!pathname.startsWith('/calendar')) {
        setMembership(prev => ({
          ...prev,
          data: null,
          isSelected: false
        }));
      }
    };
  }, [pathname]);

  useEffect(() => {
    if (lectureScheduleId || personalScheduleId) {
      setHiddenTab(true);
      setActiveTab(lectureScheduleId ? 'LECTURE' : 'PERSONAL');
    }
  }, [lectureScheduleId, personalScheduleId]);

  const isModify = lectureScheduleId || personalScheduleId;

  return (
    <>
      {!isModify && <CoachMark />}
      <PrevHeaderBarWithTitleTemplate
        title={isModify ? '일정 수정' : '일정 추가'}
        defaultBackground
        rightContents={
          <S.ButtonSubmit onClick={handleSave}>저장</S.ButtonSubmit>
        }
        onPrev={() => {
          clearSelectedLecture();
          clearGroupMembers();
          navigate('/manage', { state: 'schedule' });
        }}
      >
        <S.Container>
          {!hiddenTab && (
            <CoachMark.SpotLight>
              <CoachMark.Tooltip
                message={`회원의 수업과 기타 일정을 구분해서 등록할 수 있어요`}
              />
              <S.TabListSticky>
                <S.TabList>
                  {SCHEDULE_REGISTRATION_TAB_LIST.map(tab => (
                    <S.TabItem
                      key={tab.value}
                      isActive={tab.value === activeTab}
                      onClick={() => setActiveTab(tab.value)}
                    >
                      <p className="pb-2">{tab.label}</p>
                    </S.TabItem>
                  ))}
                </S.TabList>
              </S.TabListSticky>
            </CoachMark.SpotLight>
          )}
          {activeTab === 'LECTURE' ? (
            <LectureScheduleContents ref={lectureScheduleRef} />
          ) : (
            <PersonalScheduleContents ref={personalScheduleRef} />
          )}
        </S.Container>
      </PrevHeaderBarWithTitleTemplate>
    </>
  );
}
